<template lang="html">

<div class="slds-dropdown-trigger slds-dropdown-trigger_click slds-is-open">
  {{ $t(label) }} 

  <svg v-if="symbol" class="slds-icon slds-icon_selected slds-icon_x-small slds-icon-text-default slds-m-right_x-small" aria-hidden="true">
    <use v-bind:xlink:href="'/assets/icons/utility-sprite/svg/symbols.svg#'+symbol"></use>
  </svg>


  <button v-on:click="opened=!opened" v-on:blur="preblur" class="slds-button slds-button_icon slds-button_icon-border-filled" aria-haspopup="true" title="Show More">
    <svg class="slds-button__icon" aria-hidden="true">
      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#down"></use>
    </svg>
    <span class="slds-assistive-text">Show More</span>
  </button>
  <div v-if="opened" class="slds-dropdown slds-dropdown_left">
    <ul class="slds-dropdown__list" role="menu" aria-label="Show More">
      <li v-bind:class="{'slds-is-selected': entry.checked}" v-for="(entry, index) in entries" v-bind:key="entry.name" class="slds-dropdown__item" role="presentation">
        <a v-on:click.prevent="clickTab(index)" href="#" role="menuitem" tabindex="0">

          <svg class="slds-icon slds-icon_selected slds-icon_x-small slds-icon-text-default slds-m-right_x-small" aria-hidden="true">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#check"></use>
          </svg>

          <span class="slds-truncate pippo" v-bind:title="entry">{{ $t(entry.label) }}</span>

          <svg v-if="entry.icon"  v-bind:style="{ 'fill': entry.color}" class="slds-icon slds-icon_x-small slds-icon-text-default slds-m-left_small slds-shrink-none" aria-hidden="true">
            <use v-bind:xlink:href="'/assets/icons/utility-sprite/svg/symbols.svg#'+entry.icon"></use>
          </svg>

        </a>
      </li>
    </ul>
  </div>
</div>

</template>

<script>
export default {
  name: 'dropmenu',
  components: {

  },
  props: {
    entries: Array,
    label: String,
    symbol: String
  },
  data() {
    return {
      opened:false,
      timerBlur:{}
    }
  },
  computed: {

  },
  mounted: function() {
  },
  async created() {

  },
  methods: {
    preblur: function() {
      if (!this.opened) return;
      console.log('preblur');
      if (this.timerBlur) clearTimeout(this.timerBlur);
      var self=this;
      this.timerBlur=setTimeout(function() {
        console.log('blurring');
        self.opened=false;
      }, 200);
    },
    clickTab: function(index) {
      this.opened=false;
      this.$emit('click', index);
    },
  }
}
</script>

<style scoped>

</style>
